import "./SetApartSection.css"
import { useNavigate } from "react-router-dom"

export default function SetApartSection() {
  const navigate = useNavigate()

  return (
    <section className="set-apart-section">
      <div className="container">
        <div className="set-apart-content">
          {/* Left side - Header and button */}
          <div className="set-apart-header">
            <div className="header-text">
              <h2 className="what-sets-text">WHAT</h2>
              <h2 className="sets-us-text">SETS US</h2>
              <h3 className="apart-text">APART</h3>
            </div>
            <button
              type="button"
              className="why-us-button"
              onClick={() => navigate("/company/why-us")}
            >
              WHY US
            </button>
          </div>

          {/* Right side - 4 columns, 2 cards each, brick/tile pattern */}
          <div className="features-container">
            {/* Column 1 - Offset pattern */}
            <div className="feature-card">
              <img src="/icons/benefit1.webp" alt="Build to scale icon" className="feature-icon" />
              <h4 className="feature-title">BUILD TO SCALE</h4>
            </div>
            <div className="feature-card">
              <img src="/acceleration.webp" alt="Digital acceleration icon" className="feature-icon" />
              <h4 className="feature-title">DIGITAL ACCELERATION WITH A LEAN MINDSET</h4>
            </div>

            {/* Column 2 - Regular pattern */}
            <div className="feature-card">
              <img src="/process.webp" alt="Process oriented icon" className="feature-icon" />
              <h4 className="feature-title">HIGHLY PROCESS-ORIENTED</h4>
            </div>
            <div className="feature-card">
              <img src="/technical.webp" alt="Technical excellence icon" className="feature-icon" />
              <h4 className="feature-title">TECHNICAL EXCELLENCE</h4>
            </div>

            {/* Column 3 - Offset pattern (same as column 1) */}
            <div className="feature-card">
              <img src="/elite.webp" alt="Work with 1% icon" className="feature-icon" />
              <h4 className="feature-title">WORK WITH THE 1%</h4>
            </div>
            <div className="feature-card">
              <img src="/human.webp" alt="Human centric icon" className="feature-icon" />
              <h4 className="feature-title">HUMAN-CENTRIC</h4>
            </div>

            {/* Column 4 - Regular pattern (same as column 2) */}
            <div className="feature-card">
              <img src="/transparency.webp" alt="Transparency icon" className="feature-icon" />
              <h4 className="feature-title">FULL TRANSPARENCY</h4>
            </div>
            <div className="feature-card">
              <img src="/partner.webp" alt="Partner advisor icon" className="feature-icon" />
              <h4 className="feature-title">PARTNER & ADVISOR</h4>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
